'use strict';

import BaseComponent from "./BaseComponent.js";

export default class Draggable extends BaseComponent {
	/**
	 * @type Sortable
	 */
	#parentSortable;

	/**
	 * @type {[
	 * 	{
	 * 		sortable: Sortable,
	 * 		element: HTMLElement
	 * 	}
	 * ]}
	 */
	#sortables = [];

	#args;

	#defaultArgs = {
		groupSelector: null,
		itemSelector: null,
		parentGroup: null,
		handle: null,
		animation: 150,
		sortableArgs: {},
	}

	#options = {};

	// Change isAutoScrollMounted to be a static property of Sortable
	static isAutoScrollMounted = false;

	constructor(args) {
		super();

		this.#args = this.parseArgs(this.#defaultArgs, args);

		this.#initialize();
	}

	async #initialize() {
		const args = this.#args;

		const { default: Sortable, AutoScroll } = await import('sortablejs/modular/sortable.core.esm.js');

		if (!Draggable.isAutoScrollMounted) {
			Sortable.mount(new AutoScroll());
			Draggable.isAutoScrollMounted = true;
		}

		this.Sortable = Sortable;

		this.#options = {
			animation: this.#args.animation,
			draggable: this.#args.itemSelector,
		}

		if (this.#args.handle) {
			this.#options.handle = this.#args.handle;
		}

		if (this.#args.groupSelector) {
			this.#options.group = 'nested';
		}

		this.#options = { ...this.#options, ...this.#args.sortableArgs };

		this.#parentSortable = new this.Sortable(this.#args.parentGroup, this.#options);

		this.update();
	}

	update() {
		if (this.#args.groupSelector) {
			this.#args.parentGroup.querySelectorAll(this.#args.groupSelector).forEach(group => {
				if (!this.#sortables.find(s => s.element === group)) {
					const sortable = new this.Sortable(group, this.#options);

					this.#sortables.push({ element: group, sortable });
				}
			});
		}
	}
}
